import { render, staticRenderFns } from "./accountsAccessBlockEdit.vue?vue&type=template&id=40ecad58&scoped=true&"
import script from "./accountsAccessBlockEdit.vue?vue&type=script&lang=js&"
export * from "./accountsAccessBlockEdit.vue?vue&type=script&lang=js&"
import style0 from "./accountsAccessBlockEdit.vue?vue&type=style&index=0&id=40ecad58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ecad58",
  null
  
)

export default component.exports